import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { RectangleWithCorners } from "../utils/RectangleWithCorners";
import { SponsorManager, WhyCallAd } from "../SponsorManager";
import { GameModel } from "../GameModel";
import { AudioManager } from "../AudioManager";
import { Boot } from "./Boot";

export class ResignLayer extends Phaser.Group {

    constructor(game: Phaser.Game) {

        super(game, null, "help-layer");

        const scaledItems: Phaser.Group = new Phaser.Group(this.game);
        scaledItems.x = GameConstants.GAME_WIDTH / 2;
        this.add(scaledItems);
        
        scaledItems.scale.x = GameVars.scaleX;
        
        const rectangleWidth = 600;
        
        const rectangleWithCorners = new RectangleWithCorners(this.game, 0, 160, rectangleWidth, 290, 25, "#425271", .8);
        rectangleWithCorners.x -= rectangleWidth / 2;
        scaledItems.add(rectangleWithCorners);
        
        const resignLabel = new Phaser.BitmapText(this.game, 0, 180, "beacon", "Are you sure\nyou want to resign?", 92);
        resignLabel.x -= resignLabel.width / 2;
        resignLabel.align = "center";
        scaledItems.add(resignLabel);
        
        const yesButton = new Phaser.Button(this.game, -115, 496, "texture_atlas_1", this.onClickYes, this);
        yesButton.setFrames("button-yes-on.png", "button-yes-off.png", "button-yes-on.png");
        yesButton.anchor.setTo(.5, .5);
        scaledItems.add(yesButton);
        
        const noButton = new Phaser.Button(this.game, 115, 496, "texture_atlas_1", this.onClickNo, this);
        noButton.setFrames("button-no-on.png", "button-no-off.png", "button-no-on.png");
        noButton.anchor.setTo(.5, .5);
        scaledItems.add(noButton); 
    }
    
    private onClickYes(b: Phaser.Button): void {
        
        SponsorManager.adFilter(() => {
            b.clearFrames();
            GameModel.currentInstance.onYesResign();
            AudioManager.getInstance().playSound("click");
        }, Boot.currentInstance.game, WhyCallAd.onClickRetry);
    }
    
    private onClickNo(b: Phaser.Button): void {
        
        b.clearFrames();
            
        GameModel.currentInstance.onNoResign();
        
        AudioManager.getInstance().playSound("click");
    }
}
